/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Videourl1Inputs */

const en__field_videourl1 = /** @type {(inputs: _Field_Videourl1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video URL`)
};

/**
* | output |
* | --- |
* | "Video URL" |
*
* @param {_Field_Videourl1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const _field_videourl1 = /** @type {((inputs?: _Field_Videourl1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Videourl1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en__field_videourl1(inputs)
});
export { _field_videourl1 as "_field_videoUrl" }